import useSWRImmutable from 'swr/immutable';
import capsFetcher from '../../shared/capsFetcher';
import useApplication from '../../applications/read';

const fetcher = async (key) => {
  const res = await capsFetcher({
    url: key,
  });
  return res.data;
};

const useRepair = (options) => {
  const { data: application } = useApplication();
  return useSWRImmutable(
    `/repairs/${application.relationships.repair.data.id}`,
    fetcher,
    { suspense: true, ...options },
  );
};

export default useRepair;
